module.exports = __webpack_public_path__ + "img/f_and_p_top.27059744.jpg";